export { default as Img200 } from './processed/200/Sopranos-The-S2.jpg';
export { default as Img400 } from './processed/400/Sopranos-The-S2.jpg';
export { default as Imgthumb } from './processed/thumb/Sopranos-The-S2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Sopranos-The-S2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Sopranos-The-S2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      236,
      44,
      68
    ],
    "_population": 2,
    "_hsl": [
      0.9791666666666666,
      0.8347826086956522,
      0.5490196078431373
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      91,
      19,
      21
    ],
    "_population": 375,
    "_hsl": [
      0.9953703703703703,
      0.6545454545454545,
      0.21568627450980393
    ]
  },
  "Muted": {
    "_rgb": [
      124,
      124,
      124
    ],
    "_population": 264,
    "_hsl": [
      0,
      0,
      0.48627450980392156
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      188,
      188
    ],
    "_population": 253,
    "_hsl": [
      0,
      0,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      68,
      60,
      60
    ],
    "_population": 1,
    "_hsl": [
      0,
      0.0625,
      0.25098039215686274
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Sopranos-The-S2.js